import { BaseEnum } from "./base.enum";

export class FileImportPageTypes extends BaseEnum {
    public static readonly ImportUsers = new FileImportPageTypes({ id: 1, name: "Import Users" });
    public static readonly ImportGroups = new FileImportPageTypes({ id: 2, name: "Import Groups" });

    public static GetAll(): FileImportPageTypes[] { return [this.ImportUsers, this.ImportGroups]; }
}